import clsx from "clsx";

interface PillProps {
  text: string | number;
  icon?: React.ReactNode;
  className?: string;
}

export const Pill: React.FC<PillProps> = ({ text, icon, className }) => {
  return (
    <div
      className={clsx(
        "inline-flex items-center gap-2 rounded-full px-4 py-1",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        {icon}
        <span className="text-sm">{text}</span>
      </div>
    </div>
  );
};
